import React from 'react';
import { Select, Form } from 'antd';

const { Option } = Select;

const CustomSelect = ({ label, name, options, rules, ...props }) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      style={{ marginBottom: 0 }}
    >
      <Select
        {...props}
        showSearch
        optionFilterProp="children"
        className='custom-select'
        dropdownClassName='custom-select-dropdown'
        style={{
          height: 40,
          lineHeight: '40px',
          display: 'flex',
        }}
      >
        {options?.map((option, index) => (
          <Option key={index} value={option?.value}>
            {option?.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default CustomSelect;
